import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
import { CHECKOUT_URL } from '../utils/constants';
export function FloatingCTA() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const anchor = document.getElementById('cta-hero');
    if (!anchor) return;
    const observer = new IntersectionObserver(([entry]) => {
      const passed = !entry.isIntersecting && entry.boundingClientRect.top < 0;
      setVisible(passed);
    }, {
      threshold: 0
    });
    observer.observe(anchor);
    return () => observer.disconnect();
  }, []);
  return <AnimatePresence data-id="element-44" data-mp="2avkz6piral0g">
      {visible ? <motion.div initial={{
      y: 80,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 80,
      opacity: 0
    }} transition={{
      duration: 0.25,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed inset-x-0 bottom-0 z-40 px-3 pb-3" data-id="element-45" data-mp="2aujm6fi6jog3">
          <div className="mx-auto w-full max-w-md" data-id="element-46" data-mp="2z1pf13dvdk5s">
            <a href={CHECKOUT_URL} className="animate-rdd-shake flex w-full items-center justify-center gap-2 rounded-2xl bg-cta px-4 py-4 text-center text-[15px] font-extrabold uppercase leading-tight tracking-tight text-white shadow-[0_14px_34px_-10px_rgba(10,37,64,0.65)] transition-colors duration-200 ease-out hover:bg-cta-dark focus-visible:outline-none focus-visible:ring-4 focus-visible:ring-white/50" data-id="element-47" data-mp="2z425y61lv4uz">
              Get Renal Decision Desk™ — $27
              <ArrowRightIcon className="h-5 w-5 shrink-0" aria-hidden="true" data-id="element-48" data-mp="2kayp60vu8v5b" />
            </a>
          </div>
        </motion.div> : null}
    </AnimatePresence>;
}